var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:'font-bold ' + _vm.statusColor},[_c('b',[_vm._v(" "+_vm._s(_vm.$t(`extensions-monitor.table.statuses.${_vm.rowData.status}`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }